(function () {
    if (window.__addonDelegatedV8) return;
    window.__addonDelegatedV8 = true;

    const addonVariantId = 44828644901055;
    const toggleSelector = '.addon-toggle__input';
    const formSelector = 'form[data-type="add-to-cart-form"]';
    const customButtonSelector = '.add-to-cart-js';

    const ADD_URL = '/cart/add.js';

    const inFlightByEl = new WeakMap(); // el -> boolean
    const enabledByRoot = new WeakMap(); // root -> boolean

    function getRoot(el) {
        if (!el) return document;
        return (
            el.closest('[data-section-id]') ||
            el.closest('.shopify-section') ||
            el.closest('product-form') ||
            el.closest('main') ||
            document
        );
    }

    function setEnabled(root, v) {
        if (!root || root === document) return;
        enabledByRoot.set(root, !!v);
    }

    function getEnabled(root) {
        if (!root || root === document) return null;
        return enabledByRoot.has(root) ? !!enabledByRoot.get(root) : null;
    }

    function findToggleInContext(sourceEl) {
        const root = getRoot(sourceEl);

        if (root && root !== document) {
            const t = root.querySelector(toggleSelector);
            if (t) return t;
        }

        const all = Array.from(document.querySelectorAll(toggleSelector));
        if (!all.length) return null;

        const checked = all.find((x) => x && x.checked);
        return checked || all[0];
    }

    function isAddonEnabled(sourceEl) {
        const root = getRoot(sourceEl);
        const t = findToggleInContext(sourceEl);

        if (t) {
            if (root && root !== document) setEnabled(root, !!t.checked);
            return !!t.checked;
        }

        const cached = getEnabled(root);
        return cached === null ? false : cached;
    }

    async function addAddonOnce() {
        const res = await fetch(ADD_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            cache: 'no-store',
            body: JSON.stringify({ id: addonVariantId, quantity: 1 })
        });

        if (!res.ok) throw new Error('Addon add failed');
        await res.json().catch(() => null);
    }

    function lock(el) {
        inFlightByEl.set(el, true);
    }

    function unlock(el) {
        inFlightByEl.delete(el);
    }

    function isLocked(el) {
        return !!inFlightByEl.get(el);
    }

    // Mantener cache del toggle aunque re-rendericen el input
    document.addEventListener(
        'change',
        function (e) {
            const t = e.target && e.target.closest && e.target.closest(toggleSelector);
            if (!t) return;
            const root = getRoot(t);
            if (root && root !== document) setEnabled(root, !!t.checked);
        },
        true
    );

    // =========================
    // Flujo B: FORM principal
    // =========================
    document.addEventListener(
        'submit',
        async function (e) {
            const form = e.target && e.target.closest && e.target.closest(formSelector);
            if (!form) return;

            if (form.__addonBypassSubmit) {
                form.__addonBypassSubmit = false;
                return;
            }

            if (!isAddonEnabled(form)) return;

            if (isLocked(form)) return;

            e.preventDefault();
            e.stopImmediatePropagation();

            lock(form);

            try {
                await addAddonOnce();
            } catch (_) {
            } finally {
                unlock(form);

                // Re-disparar submit original sin loop
                form.__addonBypassSubmit = true;

                if (typeof form.requestSubmit === 'function') {
                    try {
                        form.requestSubmit();
                        return;
                    } catch (_) { }
                }

                form.submit();
            }
        },
        true
    );

    // =========================
    // Flujo A: BOTÓN .add-to-cart-js (externo al form principal)
    // =========================
    document.addEventListener(
        'click',
        async function (e) {
            const btn = e.target && e.target.closest && e.target.closest(customButtonSelector);
            if (!btn) return;

            // Si este botón está dentro del form principal, NO lo manejamos aquí
            const inMainForm = btn.closest(formSelector);
            if (inMainForm) return;

            if (btn.__addonBypassClick) {
                btn.__addonBypassClick = false;
                return;
            }

            if (!isAddonEnabled(btn)) return;

            if (isLocked(btn)) return;

            e.preventDefault();
            e.stopImmediatePropagation();

            lock(btn);
            btn.disabled = true;

            try {
                await addAddonOnce();
            } catch (_) {
            } finally {
                unlock(btn);
                btn.disabled = false;

                // Re-disparar acción original del botón sin loop
                btn.__addonBypassClick = true;
                btn.click();
            }
        },
        true
    );
})();


(function () {
    let initialized = false;

    const initAddonModal = () => {
        const modal = document.getElementById('tracker-card-modal');
        const triggers = document.querySelectorAll('.addon-tracker-card__learn');

        if (!modal || !triggers.length) {
            initialized = false;
            return;
        }

        const closeBtn = modal.querySelector('[data-addon-modal-close]');
        const backdrop = modal.querySelector('[data-addon-modal-backdrop]');

        const openModal = () => {
            modal.style.display = 'block';
            modal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
        };

        const closeModal = () => {
            modal.style.display = 'none';
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        };

        triggers.forEach(trigger => {
            trigger.addEventListener('click', e => {
                console.log('open modal');
                e.preventDefault();
                openModal();
            });
        });

        if (!modal.dataset.addonModalCloseBound) {
            closeBtn && closeBtn.addEventListener('click', closeModal);
            backdrop && backdrop.addEventListener('click', closeModal);

            document.addEventListener('keydown', e => {
                if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
                    closeModal();
                }
            });

            modal.dataset.addonModalCloseBound = 'true';
        }

        initialized = true;
    };

    // ▶️ Ejecutar al cargar
    initAddonModal();

    // ▶️ Re-ejecutar después de hacer click en tabs PDP
    document.addEventListener('click', e => {
        const tab = e.target.closest('.custom-tabs-pdp .item');
        if (!tab) return;

        // Espera a que el PDP se re-renderice
        setTimeout(() => {
            initAddonModal();
        }, 3000);
    });
})();

